import React, { useState } from 'react'
import { SidePanelInfo, ButtonV2 } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'
import { HelpContent } from './HelpContent/HelpContent'
import helpData from '../../mocks/HelpData.json'
import { Typography } from '@mui/material'
import { useStyles } from './HelpDrawer.styles'
import { useTracker } from '../../utils/Tracker/hook'

export interface HelpTextData {
  type: string
  text?: string
  link?: string
  linkText?: string
  badgeVariant?: 'lightBlue' | 'purple'
  label?: string
  question?: string
  helpAnswer?: HelpTextData[]
}
export interface HelpContentData {
  question: string
  helpAnswer: HelpTextData[]
  isCollapsible?: boolean
}
export interface HelpContentForSidePanel {
  title: string
  content: HelpContentData[]
}
const faqs = helpData as Record<string, HelpContentForSidePanel>
export interface HelpDrawerProps {
  headerTitle: string
  sectionName: string
  type?: 'button' | 'text'
  helpTextTitle?: string
  dataOrder?: string[]
  helpDrawerText?: string
}
export const HelpDrawer = React.memo(
  ({
    headerTitle,
    sectionName,
    type = 'button',
    helpTextTitle,
    helpDrawerText,
  }: HelpDrawerProps) => {
    const tracker = useTracker()
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [sectionData, setSectionData] = useState<HelpContentForSidePanel>(
      {} as HelpContentForSidePanel
    )
    const { classes: styles } = useStyles()
    const openDrawer = () => {
      setSectionData(faqs[sectionName])
      setIsOpen(true)
      tracker?.track({
        product: 'OPPSYNC',
        section: sectionName,
        component: 'help-drawer',
        action: 'opened',
        title: headerTitle,
      })
    }
    const toggleDrawer = async () => {
      setSectionData({} as HelpContentForSidePanel)
      setIsOpen(false)
    }

    return (
      <>
        {type === 'button' ? (
          <div key={`${sectionName}-${headerTitle}`}>
            <ButtonV2
              key={`${sectionName}-${headerTitle}`}
              styleType="link"
              data-testid="help-button-drawer"
              icon={
                <FontAwesomeIcon
                  icon={faCircleInfo}
                  style={{ height: '16px', width: '16px', fontSize: '16px' }}
                />
              }
              onClick={openDrawer}
              smallVariant
            >
              {helpDrawerText ? helpDrawerText : 'Help & FAQs'}
            </ButtonV2>
          </div>
        ) : (
          <Typography className={styles.textUrl} onClick={openDrawer}>
            {helpTextTitle ? helpTextTitle : 'Help'}
          </Typography>
        )}
        <SidePanelInfo
          icon={
            <FontAwesomeIcon
              icon={faCircleInfo}
              style={{ width: '24px', height: '24px', fontSize: '24px' }}
            />
          }
          headerTitle={headerTitle}
          title={sectionData?.title}
          open={isOpen}
          onClose={toggleDrawer}
          content={<HelpContent helpContent={sectionData?.content} />}
        />
      </>
    )
  }
)
